module.exports = __webpack_public_path__ + "img/v4_h4.ad37d79b.png";